const getDefaultState = () => {
    return {
        tabsList: []
    }
}

export default{
    actions:{

    },
    mutations:{
        selectMenu(state, val) {
            let result = state.tabsList.findIndex(item => item.route === val.route)
                 result === -1 ? state.tabsList.push(val) : ''
            localStorage.setItem("tags",JSON.stringify(state.tabsList))
        },
        deleteMens(state, val) {
            localStorage.setItem("tags",JSON.stringify(state.tabsList))
        },
        //关闭标签
        closeTab(state, val) {
            let result = state.tabsList.findIndex(item => item.route === val.route)
            state.tabsList.splice(result, 1)
        },
        RESET_STATE: (state) => {
            Object.assign(state, getDefaultState())
        },
    },
    state:{
        tabsList: localStorage.getItem("tags") ? JSON.parse(localStorage.getItem("tags")) : [],
    },
}